import { useState, useEffect } from 'react';
import { Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Button } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { setStockoutreqGenStockOutReqModal, setMfproductorderList } from 'store/slice/ManufSlice';
import { genStockOutReqAPI } from 'api/OmsFactoryopsWebServices';
import { getListAPI as getProductOrderListAPI } from 'components/mfproductorder/MfproductorderAPI';
import { addStockoutreqObj } from 'store/slice/ManufSlice';

export default function GenStockOutReqActionImpl() {
    const dispatch = useDispatch();
    const { selectedProductOrderForStockOutReqId } = useSelector((state) => state.appslice);
    const { mfproductorderList } = useSelector((state) => state.manufslice);
    const [productOrderList, setProductOrderList] = useState([]);
    const [apiInProgress, setApiInProgress] = useState(false);
    const [newStockoutReqObj, setNewStockoutReqId] = useState({});
    const [stockoutProductList, setStockoutProductList] = useState([]);
    const [errMsg, setErrMsg] = useState('');

    useEffect(() => {
        if (mfproductorderList && mfproductorderList.length > 0) {
            const filteredOrders = mfproductorderList.filter(order => selectedProductOrderForStockOutReqId.includes(order.id));
            setProductOrderList(filteredOrders);
        }
    }, [mfproductorderList, selectedProductOrderForStockOutReqId]);

    const handleCancel = () => {
        dispatch(setStockoutreqGenStockOutReqModal(false));
    };

    const handleGenerate = () => {
        setErrMsg('');
        setApiInProgress(true);
        genStockOutReqAPI({
            productOrderList: selectedProductOrderForStockOutReqId},
            getManufServiceAPISuccessCallback,
            getManufServiceAPIFailureCallback
        )
    };
    const getProductOrderListApiSuccessCallback = (list) => {
        dispatch(setMfproductorderList(list));
    }
    const getManufServiceAPISuccessCallback = (response) => {
       console.log("Stock Out Request generated successfully:", JSON.stringify(response));
       setNewStockoutReqId(response.stockoutreqInfo);
       dispatch(addStockoutreqObj(response.stockoutreqInfo));
       setStockoutProductList(response.stockoutproductInfoList.list);
       setProductOrderList([]); // Clear the product order list after successful generation

       // Refetch the product order list to ensure it reflects the latest state
       getProductOrderListAPI(() => {}, getProductOrderListApiSuccessCallback);
    }
    const getManufServiceAPIFailureCallback = (errMsg) => {
        setErrMsg(errMsg);
        setApiInProgress(false);
    }
    return (
        <>
        
            {newStockoutReqObj && newStockoutReqObj.id ? (
                <>
                <Typography variant="h5" color="primary" sx={{ padding: 2 }}>
                    Stock Out Request generated successfully with ID: {newStockoutReqObj.id} with following Products:
                </Typography>
                <Grid container direction="row" sx={{ padding: 1 }}>
                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Product Name</TableCell>
                                        <TableCell>Quantity</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {stockoutProductList && stockoutProductList.map((stockoutProductObj, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{stockoutProductObj.productname}</TableCell>
                                            <TableCell>{stockoutProductObj.qty}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 2 }}>
                            <Button variant="contained"  onClick={handleCancel}>
                                Close
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
                </>
            ) : null}
            {productOrderList.length > 0 ? (
                <Grid container direction="row" sx={{ padding: 1 }}>
                    <Grid item xs={12} sx={{ mb: 2 }}>
                        <Typography variant="h5">
                            Are you sure to generate Stock Out Request for following Products?
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Order Id</TableCell>
                                        <TableCell>Product Name</TableCell>
                                        <TableCell>Quantity</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {productOrderList.map((productOrderObj, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{productOrderObj.orderid}</TableCell>
                                            <TableCell>{productOrderObj.productname}</TableCell>
                                            <TableCell>{productOrderObj.qty}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    {   errMsg && errMsg!=='' ?(
                        <>
                        <Typography variant="body1" color="error" sx={{ padding: 2 }}>
                            {errMsg}
                        </Typography>
                        <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent:'flex-end'}}>
                            <Button variant="contained"  onClick={handleCancel}>
                                Close
                            </Button>
                        </Box>
                        </Grid>
                        </>
                    ):
                   
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 2 }}>
                            <Button variant="outlined" color="secondary" onClick={handleCancel}>
                                Cancel
                            </Button>
                            <Button variant="contained" color="primary" onClick={handleGenerate}>
                                Generate
                            </Button>
                        </Box>
                    </Grid>
                     }
                </Grid>
            ) : null}
        </>
    );
}